module.exports = __webpack_public_path__ + "img/mark-H.ff045fe.svg";